<template>
    <div>
        <images-carousel
            :galleryElements="galleryElements"
            @onImageClick="displayGallery = true"
            v-model="currentSlide"
            no-shadow
            :hide-controls="$vuetify.breakpoint.mdAndUp ? true : false"
            height="auto"
            :paginator="$vuetify.breakpoint.mdAndUp ? 'prime-carousel-preview-pagination' : 'prime-carousel-numbers-pagination'"
            contain
            :loop="true"
            :discount-rate="discountRate"
            ref="carousel"
        />

        <wheel-zoomer
            v-model="displayGallery"
            :galleryElements="galleryElements"
            :currentSlide="currentSlide"
            @slideChange="onSlideChange"
        />
    </div>
</template>

<style lang="stylus">
@import '~vuetify/src/stylus/settings/_variables';

@media (min-width: $grid-breakpoints.md) {
    .product-carousel {
        padding-left: 85px;
    }
}

.product-carousel {
    .prime-carousel-preview-pagination.v-carousel__controls {
        width: auto;
        top: 0;
        left: 0;
        height: auto;
    }

    .v-window-item {
        height: 100%;
    }

    .prime-carousel-numbers-pagination.v-carousel__controls {
        justify-content: flex-end;
        padding: 0 15px;
    }
}
</style>

<script>
import WheelZoomer from './ImagesAndVideos/WheelZoomer';
import ImagesCarousel from './ImagesAndVideos/ImagesCarousel';
import { createNamespacedHelpers } from 'vuex';
import PrimeCarouselPreviewPagination from './ImagesAndVideos/PrimeCarouselPreviewPagination';
import PrimeCarouselNumbersPagination from './ImagesAndVideos/PrimeCarouselNumbersPagination';
import Vue from 'vue';

const parentModuleName = 'Product';
const { mapState, mapGetters } = createNamespacedHelpers(parentModuleName);

export default {
    name: 'ImagesAndVideos',
    components: {
        WheelZoomer,
        ImagesCarousel,
    },
    data() {
        return {
            currentSlide: 0,
            displayGallery: false,
        };
    },
    beforeCreate() {
        Vue.component('prime-carousel-preview-pagination', PrimeCarouselPreviewPagination);
        Vue.component('prime-carousel-numbers-pagination', PrimeCarouselNumbersPagination);
    },
    computed: {
        ...mapGetters(['getDiscountRate']),
        ...mapState({
            items: state => state.product && state.product.images.product_images ? state.product.images.product_images : [],
            price: state => state.product.price,
        }),
        galleryElements() {
            return this.items.filter(i => !i.video_source);
        },
        discountRate() {
            return this.price.discount ? this.getDiscountRate(this.price) : 0;
        },
    },
    methods: {
        onSlideChange(value) {
            this.currentSlide = value;
        },
    },
};
</script>
